import defaultAttributes from '../defaultAttributes';

const CircleSlashed = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M22 2 2 22' }],
  ],
];

export default CircleSlashed;
